import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Map } from "immutable";
import Logout from "MODULES/session/components/Logout";
import { dismissibleChild } from "MODULES/shared/decorators";
import { UUID } from "APP_ROOT/constants";
import { USER } from "MODULES/users/constants";

export class SessionInfo extends Component {
  static propTypes = {
    currentUser: PropTypes.instanceOf(Map).isRequired,
    pushHistory: PropTypes.func.isRequired
  };

  componentWillUnmount() {
    this.setState({ open: false });
  }

  navToProfile = () => {
    this.setState({ open: false });
    this.props.pushHistory(`/users/${this.props.currentUser.get(UUID)}`);
    this.props.close();
  };

  render() {
    if (this.props.currentUser.isEmpty()) {
      return (
        <li>
          <Link className="btn btn-primary" to="/login">
            Login
          </Link>
        </li>
      );
    }

    const { close, visible, toggle, contentRef } = this.props;
    const classes = classNames({ open: visible });
    return (
      <li className={classes} ref={contentRef}>
        <a onClick={toggle} className="dropdown-toggle" id="session-nav">
          <i
            className="fa fa-user"
            style={{ fontSize: "1.75em", lineHeight: ".25em" }}
            aria-hidden="true"
          />{" "}
          <span className="hidden-xs hidden-sm caret" />
        </a>
        <ul className="dropdown-menu">
          <li>
            <a onClick={this.navToProfile} type="button" role="button">
              <i className="fa fa-fw fa-btn fa-cog" /> Profile
            </a>
          </li>
          <li onClick={close}>
            <Link to="/reports/commissions">
              <i className="fa fa-fw fa-btn fa-percent" /> Commission Report
            </Link>
          </li>
          <li>
            <Logout />
          </li>
        </ul>
      </li>
    );
  }
}

SessionInfo.propTypes = {
  close: PropTypes.func.isRequired,
  contentRef: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired
};

export default connect(
  state => ({
    currentUser: state.session.get(USER)
  }),
  { pushHistory: push }
)(dismissibleChild(SessionInfo));



// WEBPACK FOOTER //
// ./app/Nav/SessionInfo.jsx